/**
 * @generated SignedSource<<1f23ac1ec79a90ef2138fb991e133bfc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventTimetableFragment$data = {
  readonly timetable: any | null | undefined;
  readonly " $fragmentType": "EventTimetableFragment";
};
export type EventTimetableFragment$key = {
  readonly " $data"?: EventTimetableFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventTimetableFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventTimetableFragment",
  "selections": [
    {
      "alias": "timetable",
      "args": null,
      "kind": "ScalarField",
      "name": "agenda",
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "a27acea2ebf060154783048a4ac8cde9";

export default node;
